import { makeStyles } from "@material-ui/styles";
import SmartChargingInput from "./SmartChargingInput";
import SmartChargingOutput from "./SmartChargingOutput";
import React from "react";


const SmartCharging = (props) => {

  return (
    <React.Fragment>
      <SmartChargingInput history={props.history} />
      <SmartChargingOutput history={props.history} />
    </React.Fragment>
  );
};

export default SmartCharging;
